import { useRouter } from 'next/router';
// config
import { SIGNUP_FORM_FREE_TRIAL, INIT_FORM_FREE_TRIAL_NAP, EX8046 } from 'config/flags';
// components
import { Disclaimer } from '../../Disclaimer';
// styles
import { useMediaQuery } from '@mui/material';
import styles from './Question.module.css';

const Question = () => {
    const { push } = useRouter();
    const isMobile = useMediaQuery('(max-width:768px)');
    const isCOL = typeof window !== 'undefined' ? navigator?.language === 'es-CO' : false;

    const handleChange = (val: string) => {
        if (val === 'A') {
            push(`/signup${SIGNUP_FORM_FREE_TRIAL}`);
        } else if (val === 'B') {
            // push a nueva url no tiene farmacia
            push(`/signup/not-a-pharmacy${INIT_FORM_FREE_TRIAL_NAP}`);
        }
    };

    return (
        <section className={styles['container']}>
            <div className={styles['wrapper-question']} style={{ gap: EX8046 ? 24 : 32 }}>
                {!EX8046 && <p className={styles['title']}>¿Tienes una farmacia?</p>}
                {EX8046 && (
                    <div className={styles['wrapper-title']} style={{ gap: isMobile ? 10 : 5 }}>
                        <p className={styles['title']}>{`¿Tienes una ${isCOL && EX8046 ? 'droguería' : 'farmacia'}?`}</p>
                        <Disclaimer />
                    </div>
                )}
                <div className={styles['wrapper-options']}>
                    <label className={styles['option']}>
                        <input type="radio" name="farmacia" value="A" onChange={(e) => handleChange(e.target.value)} />
                        <span className={styles['text']}>{`Sí, tengo una ${isCOL && EX8046 ? 'droguería' : 'farmacia'}`}</span>
                    </label>
                    <label className={styles['option']}>
                        <input type="radio" name="farmacia" value="B" onChange={(e) => handleChange(e.target.value)} />
                        <span className={styles['text']}>{`No tengo una ${isCOL && EX8046 ? 'droguería' : 'farmacia'}`}</span>
                    </label>
                </div>
            </div>
        </section>
    );
};

export default Question;
